import React from 'react';
import { Landmark, Search, Bell } from 'lucide-react';
import { Button } from '../ui/Button';
import { Avatar, AvatarFallback } from '../ui/Avatar';
import { currentOfficer } from '../../data/officers';
interface FederalHeaderProps {
  onSearch: () => void;
}
export function FederalHeader({
  onSearch
}: FederalHeaderProps) {
  const [language, setLanguage] = React.useState<'EN' | 'AR'>('EN');
  return <header className="bg-uae-green text-white" data-id="element-713" data-mp="2v8wssbuhq8x2">
      <div className="flex h-14 items-center justify-between gap-4 px-5" data-id="element-714" data-mp="2v629inn7qu58">
        <div className="flex items-center gap-3" data-id="element-715" data-mp="307rlc5i9fbud">
          <span className="flex h-8 w-8 items-center justify-center rounded-sm bg-white/10" data-id="element-716" data-mp="356l164l0rexp">
            <Landmark className="h-4 w-4" aria-hidden="true" data-id="element-717" data-mp="39x1dtmh0mwj0" />
          </span>
          <div className="leading-tight" data-id="element-718" data-mp="39z4dyzbvu61g">
            <p className="text-sm font-semibold tracking-tight" data-id="element-719" data-mp="2cifehcaenfv8">Strategic Delivery Unit</p>
            <p className="text-[11px] text-white/60" data-id="element-720" data-mp="2hg74g0rhorws">
              United Arab Emirates · Mega, Major &amp; International Events
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2" data-id="element-721" data-mp="2yr8usbcovotz">
          <Button variant="ghost" size="sm" onClick={onSearch} className="hidden text-white/80 hover:bg-white/10 hover:text-white md:inline-flex" data-id="element-722" data-mp="2trmdnqtqpofw">
            <Search className="mr-1.5 h-3.5 w-3.5" aria-hidden="true" data-id="element-723" data-mp="2kx7xlm1dy9vq" />
            Search records
            <span className="ml-2 rounded border border-white/25 px-1 font-mono text-[10px] text-white/60" data-id="element-724" data-mp="2fzpsy7ueigtj">
              /
            </span>
          </Button>

          <div className="hidden items-center rounded-sm border border-white/20 text-[11px] sm:flex" role="group" aria-label="Interface language" data-id="element-725" data-mp="26076nkr0qiyb">
            <button type="button" onClick={() => setLanguage('EN')} aria-pressed={language === 'EN'} className={`px-2 py-1 ${language === 'EN' ? 'bg-white/15 text-white' : 'text-white/60'}`} data-id="element-726" data-mp="493yr38ijihg">
              EN
            </button>
            <button type="button" onClick={() => setLanguage('AR')} aria-pressed={language === 'AR'} className={`px-2 py-1 ${language === 'AR' ? 'bg-white/15 text-white' : 'text-white/60'}`} data-id="element-727" data-mp="1ygy0s1hq12e0">
              عربي
            </button>
          </div>

          <span className="hidden rounded-sm border border-white/20 px-2 py-1 font-mono text-[11px] text-white/70 lg:inline" data-id="element-728" data-mp="2cgqxqejuceuf">
            FY 2026
          </span>

          <Button variant="ghost" size="icon-sm" aria-label="Notifications" className="text-white/80 hover:bg-white/10 hover:text-white" data-id="element-729" data-mp="23gaw7amnrhs7">
            <Bell className="h-4 w-4" aria-hidden="true" data-id="element-730" data-mp="s15f31ls5gp2" />
          </Button>

          <div className="flex items-center gap-2 border-l border-white/15 pl-3" data-id="element-731" data-mp="rzuefanmsp26">
            <Avatar className="h-7 w-7" data-id="element-732" data-mp="x1th0ibjrhy2">
              <AvatarFallback className="bg-white/15 text-[11px] text-white" data-id="element-733" data-mp="oj7xnkjmefbd">
                {currentOfficer.initials}
              </AvatarFallback>
            </Avatar>
            <div className="hidden leading-tight xl:block" data-id="element-734" data-mp="khcvkdtv7xwj">
              <p className="text-xs font-medium" data-id="element-735" data-mp="ygcnbucocswx">{currentOfficer.name}</p>
              <p className="text-[10px] text-white/60" data-id="element-736" data-mp="tikla7ibfqf0">{currentOfficer.role}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex h-1 w-full" aria-hidden="true" data-id="element-737" data-mp="5ti4f1via1lk">
        <span className="flex-1 bg-uae-red" data-id="element-738" data-mp="tx4op8ihp7s" />
        <span className="flex-1 bg-uae-leaf" data-id="element-739" data-mp="v898r9s70zy" />
        <span className="flex-1 bg-white" data-id="element-740" data-mp="fijmqypiwv2p" />
        <span className="flex-1 bg-uae-ink" data-id="element-741" data-mp="fjbhk7baqorx" />
      </div>
    </header>;
}